import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    startOverline: 'A giveaway has started',
    winOverline: 'You caught the giveaway',
    minutesOne: '{{count}} minute left',
    minutesFew: '{{count}} minutes left',
    minutesMany: '{{count}} minutes left',
    lastMinute: 'Less than a minute left',
  },
  ru: {
    startOverline: 'Началась раздача',
    winOverline: 'Ты поймал раздачу',
    minutesOne: 'Осталась {{count}} минута',
    minutesFew: 'Осталось {{count}} минуты',
    minutesMany: 'Осталось {{count}} минут',
    lastMinute: 'Осталось меньше минуты',
  },
  uz: {
    startOverline: 'Bepul keys ulashilyapti',
    winOverline: 'SHOT senga keys ulashdi',
    minutesOne: '{{count}} daqiqa qoldi',
    minutesFew: '{{count}} daqiqa qoldi',
    minutesMany: '{{count}} daqiqa qoldi',
    lastMinute: 'Bir daqiqadan kam qoldi',
  },
  fa: {
    startOverline: 'پخش کیس رایگان شروع شد',
    winOverline: 'یک کیس رایگان به تو رسید',
    minutesOne: '{{count}} دقیقه مانده',
    minutesFew: '{{count}} دقیقه مانده',
    minutesMany: '{{count}} دقیقه مانده',
    lastMinute: 'کمتر از یک دقیقه مانده',
  },
  pt: {
    startOverline: 'Começou um sorteio',
    winOverline: 'Você pegou o sorteio',
    minutesOne: 'Falta {{count}} minuto',
    minutesFew: 'Faltam {{count}} minutos',
    minutesMany: 'Faltam {{count}} minutos',
    lastMinute: 'Falta menos de um minuto',
  },
  tr: {
    startOverline: 'Çekiliş başladı',
    winOverline: 'Çekilişi yakaladın',
    minutesOne: '{{count}} dakika kaldı',
    minutesFew: '{{count}} dakika kaldı',
    minutesMany: '{{count}} dakika kaldı',
    lastMinute: 'Bir dakikadan az kaldı',
  },
  uk: {
    startOverline: 'Почалась роздача',
    winOverline: 'Ти зловив роздачу',
    minutesOne: 'Залишилась {{count}} хвилина',
    minutesFew: 'Залишилось {{count}} хвилини',
    minutesMany: 'Залишилось {{count}} хвилин',
    lastMinute: 'Залишилось менше хвилини',
  },
  de: {
    startOverline: 'Ein Giveaway hat begonnen',
    winOverline: 'Du hast das Giveaway erwischt',
    minutesOne: 'Noch {{count}} Minute',
    minutesFew: 'Noch {{count}} Minuten',
    minutesMany: 'Noch {{count}} Minuten',
    lastMinute: 'Weniger als eine Minute übrig',
  },
  es: {
    startOverline: 'Empezó un giveaway',
    winOverline: 'Pillaste el giveaway',
    minutesOne: 'Queda {{count}} minuto',
    minutesFew: 'Quedan {{count}} minutos',
    minutesMany: 'Quedan {{count}} minutos',
    lastMinute: 'Queda menos de un minuto',
  },
  pl: {
    startOverline: 'Zaczęło się rozdanie',
    winOverline: 'Złapałeś rozdanie',
    minutesOne: 'Zostanie {{count}} minuta',
    minutesFew: 'Zostały {{count}} minuty',
    minutesMany: 'Zostało {{count}} minut',
    lastMinute: 'Zostało mniej niż minuta',
  },
});
